import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button, usePromise } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import { ButtonProps } from '@digital/ui/lib/components/Button';
import ItemListComentario from './itemList';
import { Visibility } from '../Visibility';
import { IItemMsgComentario } from '@app/types/core.types';
import { isObjEmpty } from '@app/helpers/objHelper';

export interface IModalComentarioButtonProps {
    tooltip?: string;
    icon?: ButtonProps["icon"];
    titleModal?: string;
    readonly?: boolean;
    autoClick?: boolean;
    showBadgeComments?: boolean;
    reloadComentarios?: boolean;

    handleEnviarComentario?: (comentario: string) => Promise<boolean>;
    loadAllComentarios: () => Promise<IItemMsgComentario[]>;
    onReloadComentarios?: (value: boolean) => void;
}

const ModalComentarioButton = ({
    tooltip = "Comentários",
    icon = "messaging-comments",
    titleModal = "Comentários",
    readonly = true,
    autoClick = false,
    showBadgeComments = false,
    reloadComentarios = false,

    handleEnviarComentario,
    loadAllComentarios,
    onReloadComentarios,
}: IModalComentarioButtonProps) => {
    const [exibirModal, setExibirModal] = useState(false);
    const [recarregarMensagem, setRecarregarMensagem] = useState(false);
    const [iconeComentario, setIconeComentario] = useState('');
    const textAreaId = `textAreaId${Math.random()}`;
    const [allComments, setAllComments] = useState<IItemMsgComentario[]>([]);


    useEffect(() => {
        if (autoClick === true) {
            onRecarregarMensagem();
            showModal();
        }
    }, [autoClick]);

    useEffect(() => {
        if (showBadgeComments) {
            loadAllComentarios()
                .then((apiCommments) => {
                    if (apiCommments.length > 0) {
                        setIconeComentario('has-comments');
                    }
                    setAllComments(apiCommments);
                });
        }
        onReloadComentarios && onReloadComentarios(!reloadComentarios);
    }, [recarregarMensagem, reloadComentarios]);

    const onRecarregarMensagem = () => {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
    };

    const limparCampo = () => {
        let elemento = document.getElementById(textAreaId) as any;
        if (elemento != null) {
            elemento.value = '';
        }
    };

    const showModal = () => {
        limparCampo();
        setExibirModal(true);
    };

    const handleCancel = () => {
        limparCampo();
        setExibirModal(false);
    };

    return (
        <>
            <Tooltip title={tooltip}>
                <Button
                    onClick={() => {
                        onRecarregarMensagem();
                        showModal();
                    }}
                    icon={icon}
                    className={iconeComentario}
                />
            </Tooltip>
            {exibirModal && (
                <Modal
                    title={titleModal}
                    className="chat-modal"
                    // width="680px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={[
                        <Button key="submit" type="link" onClick={handleCancel}>
                            Fechar
                        </Button>,
                        <Visibility
                            visible={!readonly}
                        >
                            <Button
                                key="submit"
                                type="primary"
                                onClick={(e: any) => {
                                    const el: any = document.getElementById(textAreaId);

                                    if (el) {

                                        if (isObjEmpty(el.value)) {
                                            alert('Comentário em branco');
                                            return;
                                        }

                                        const text = el.value;

                                        handleEnviarComentario && handleEnviarComentario(text)
                                            .then(val => {
                                                if (val) {
                                                    onRecarregarMensagem();
                                                }
                                            });
                                    }
                                }}>
                                Enviar
                            </Button>
                        </Visibility>
                    ]}>
                    <ItemListComentario
                        allComentarios={allComments}
                        loadAllComentarios={loadAllComentarios}
                        recarregarMensagem={recarregarMensagem || reloadComentarios}
                    />
                    <Visibility
                        visible={!readonly}
                    >
                        <div className="chat-modal-message-box">
                            <Form>
                                <Form.Item>
                                    <TextArea
                                        id={textAreaId}
                                        placeholder="mensagem"
                                        autosize={{ minRows: 3, maxRows: 5 }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </Visibility>
                </Modal>
            )}
        </>
    );
};

export default ModalComentarioButton;